import { HazardBaseLayer } from "./HazardBaseLayer";

interface Props {
  defaultVisible: boolean;
  visible?: boolean;
}

const host = process.env.VITE_HAZARD_TILE_HOST ?? "";
const url = `${host}/40/tsunami_40.pmtiles`;

export const TSUNAMI_LAYER_NAME = "津波浸水想定（最大浸水深クラス）";

// 浸水深クラスごとの色分け
const colorMap: Record<string, string> = {
  "~0.3m": "#FFFFB3",
  "~0.5m": "#F7F5A9",
  "0.5-1m": "#F8E1A6",
  "0.5-3m": "#FFD8C0",
  "3-5m": "#FFB7B7",
  "5-10m": "#FF9191",
  "10-20m": "#F285C9",
  "20m~": "#DC7ABC",
};

const attributeKey = "A40_003_CLASS";
const dataLayer = "a40";
const minzoom = 14;
const maxzoom = 22;

/*
津波浸水想定（最大浸水深クラス）レイヤー
タイル元データ: tmp/a40/a40_class.pmtiles（A40 津波浸水想定データをクラス化）
*/
export const HazardTsunamiLayer: React.FC<Props> = ({
  defaultVisible,
  visible,
}) => {
  return (
    <HazardBaseLayer
      defaultVisible={defaultVisible}
      layerName={TSUNAMI_LAYER_NAME}
      url={url}
      attributeKey={attributeKey}
      colorMap={colorMap}
      dataLayer={dataLayer}
      minzoom={minzoom}
      maxzoom={maxzoom}
      visible={visible}
    />
  );
};
